import Routes from "./routes/routes"
import "./global.css"


function App() {
  return (
    <>
      <Routes />    
    </>
  );
}

export default App;
